"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractTokenizer_1 = require("./AbstractTokenizer");

var CharCodes_1 = require("./enum/CharCodes");

var ParamNames_1 = require("./enum/ParamNames");

var ParseError_1 = require("./errors/ParseError");

var Chars_1 = require("./utils/Chars");

function isIBiopInfo(object) {
  return object && 'prec' in object;
}

function isAllParamTypes(object) {
  return object && 'type' in object;
}

function binaryPrecedence(opVal) {
  return Chars_1.binaryOps[opVal] || 0;
}

function createBinaryExpression(operator, left, right) {
  switch (operator) {
    case '=':
    case '+=':
    case '-=':
    case '*=':
    case '/=':
    case '%=':
      return {
        type: ParamNames_1.default.AssignmentExpression,
        operator: operator,
        left: left,
        right: right
      };

    case '||':
    case '&&':
      return {
        type: ParamNames_1.default.LogicalExpression,
        operator: operator,
        left: left,
        right: right
      };

    default:
      return {
        type: ParamNames_1.default.BinaryExpression,
        operator: operator,
        left: left,
        right: right
      };
  }
}

function createUnaryExpression(operator, argument) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!argument) {
    throw new ParseError_1.default("Missing argument in ".concat(prefix ? 'before' : 'after', " '").concat(operator, "'"), {
      start: 0,
      end: 0
    });
  }

  switch (operator) {
    case '++':
    case '--':
      return {
        type: ParamNames_1.default.UpdateExpression,
        operator: operator,
        argument: argument,
        prefix: prefix
      };

    default:
      return {
        type: ParamNames_1.default.UnaryExpression,
        operator: operator,
        argument: argument,
        prefix: prefix
      };
  }
}

var ParamsParser =
/*#__PURE__*/
function (_AbstractTokenizer_1$) {
  _inherits(ParamsParser, _AbstractTokenizer_1$);

  function ParamsParser() {
    _classCallCheck(this, ParamsParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(ParamsParser).apply(this, arguments));
  }

  _createClass(ParamsParser, [{
    key: "parse",
    value: function parse(template) {
      _get(_getPrototypeOf(ParamsParser.prototype), "init", this).call(this, template);

      var nodes = [];
      var node;

      while (this.index < this.length) {
        node = this.parseExpression();

        if (node) {
          nodes.push(node);

          if (this.charCodeAt(this.index) === CharCodes_1.default.Comma) {
            ++this.index;
          }
        } else if (this.index < this.length) {
          throw new ParseError_1.default("Unexpected \"".concat(this.charAt(this.index), "\""), {
            start: this.index,
            end: this.index
          });
        }
      }

      if (nodes.length === 1) {
        return nodes[0];
      } else {
        return {
          type: ParamNames_1.default.Compound,
          body: nodes
        };
      }
    }
  }, {
    key: "parseSpaces",
    value: function parseSpaces() {
      var ch = this.charCodeAt(this.index);

      while (Chars_1.isWhitespace(ch)) {
        ch = this.charCodeAt(++this.index);
      }
    }
  }, {
    key: "parseExpression",
    value: function parseExpression() {
      var test = this.parseBinaryExpression();
      this.parseSpaces();
      return test;
    }
  }, {
    key: "parseBinaryOp",
    value: function parseBinaryOp() {
      this.parseSpaces();
      var toCheck = this.template.substr(this.index, Chars_1.maxBinopLen);
      var tcLen = toCheck.length;

      while (tcLen > 0) {
        if (Chars_1.binaryOps.hasOwnProperty(toCheck)) {
          this.index += tcLen;
          return toCheck;
        }

        toCheck = toCheck.substr(0, --tcLen);
      }

      return null;
    }
  }, {
    key: "parseBinaryExpression",
    value: function parseBinaryExpression() {
      var node;
      var biop;
      var prec;
      var stack;
      var biopInfo;
      var fbiop;
      var left;
      var right;
      var i;
      left = this.parseToken();
      biop = this.parseBinaryOp();

      if (!biop) {
        return left;
      }

      if (biop === '++' || biop === '--') {
        return createUnaryExpression(biop, left, false);
      }

      biopInfo = {
        value: biop,
        prec: binaryPrecedence(biop)
      };
      right = this.parseToken();

      if (!right || !left) {
        throw new ParseError_1.default("Expected expression after ".concat(biop), {
          start: this.index,
          end: this.index
        });
      }

      stack = [left, biopInfo, right];

      while (true) {
        biop = this.parseBinaryOp();

        if (!biop) {
          break;
        }

        prec = binaryPrecedence(biop);

        if (prec === 0) {
          break;
        }

        biopInfo = {
          value: biop,
          prec: prec
        };

        while (stack.length > 2) {
          fbiop = stack[stack.length - 2];

          if (!isIBiopInfo(fbiop) || prec > fbiop.prec) {
            break;
          }

          right = stack.pop();
          stack.pop();
          left = stack.pop();

          if (!isAllParamTypes(right) || !isAllParamTypes(left)) {
            break;
          }

          node = createBinaryExpression(fbiop.value, left, right);
          stack.push(node);
        }

        node = this.parseToken();

        if (!node) {
          throw new ParseError_1.default("Expected expression after ".concat(biop), {
            start: this.index,
            end: this.index
          });
        }

        stack.push(biopInfo, node);
      }

      i = stack.length - 1;
      node = stack[i];

      while (i > 1) {
        fbiop = stack[i - 1];
        left = stack[i - 2];

        if (!isIBiopInfo(fbiop) || !isAllParamTypes(left) || !isAllParamTypes(node)) {
          throw new ParseError_1.default("Expected expression", {
            start: this.index,
            end: this.index
          });
        }

        node = createBinaryExpression(fbiop.value, left, node);
        i -= 2;
      }

      if (!isAllParamTypes(node)) {
        throw new ParseError_1.default("Expected expression", {
          start: this.index,
          end: this.index
        });
      }

      return node;
    }
  }, {
    key: "parseToken",
    value: function parseToken() {
      var toCheck;
      var tcLen;
      this.parseSpaces();
      var ch = this.charCodeAt(this.index);

      if (Chars_1.isDecimalDigit(ch) || ch === CharCodes_1.default.Period) {
        return this.parseNumericLiteral();
      } else if (ch === CharCodes_1.default.SingleQuote || ch === CharCodes_1.default.DoubleQuote) {
        return this.parseStringLiteral();
      } else if (Chars_1.isIdentifierStart(ch) || ch === CharCodes_1.default.OpenParenthesis) {
        return this.parseVariable();
      } else if (ch === CharCodes_1.default.OpenBracket) {
        return this.parseArray();
      } else if (ch === CharCodes_1.default.OpenBrace) {
        return this.parseMap();
      } else {
        toCheck = this.template.substr(this.index, Chars_1.maxUnopLen);
        tcLen = toCheck.length;

        while (tcLen > 0) {
          if (Chars_1.unaryOps.hasOwnProperty(toCheck)) {
            this.index += tcLen;
            return createUnaryExpression(toCheck, this.parseToken(), true);
          }

          toCheck = toCheck.substr(0, --tcLen);
        }
      }

      return null;
    }
  }, {
    key: "parseNumericLiteral",
    value: function parseNumericLiteral() {
      var rawName = '';
      var chCode;

      while (Chars_1.isDecimalDigit(this.charCodeAt(this.index))) {
        rawName += this.charAt(this.index++);
      }

      if (this.charCodeAt(this.index) === CharCodes_1.default.Period) {
        rawName += this.charAt(this.index++);

        while (Chars_1.isDecimalDigit(this.charCodeAt(this.index))) {
          rawName += this.charAt(this.index++);
        }
      }

      chCode = this.charCodeAt(this.index);

      if (Chars_1.isIdentifierStart(chCode)) {
        throw new ParseError_1.default("Variable names cannot start with a number (".concat(rawName).concat(this.charAt(this.index), ")"), {
          start: this.index,
          end: this.index
        });
      } else if (chCode === CharCodes_1.default.Period) {
        throw new ParseError_1.default('Unexpected period', {
          start: this.index,
          end: this.index
        });
      }

      return {
        type: ParamNames_1.default.Literal,
        value: parseFloat(rawName),
        raw: rawName
      };
    }
  }, {
    key: "parseStringLiteral",
    value: function parseStringLiteral() {
      var str = '';
      var quote = this.charAt(this.index++);
      var closed = false;
      var ch;

      while (this.index < this.length) {
        ch = this.charAt(this.index++);

        if (ch === quote) {
          closed = true;
          break;
        } else if (ch === '\\') {
          ch = this.charAt(this.index++);
          str += "\\".concat(ch);
        } else {
          str += ch;
        }
      }

      if (!closed) {
        throw new ParseError_1.default("Unclosed quote after \"".concat(str, "\""), {
          start: this.index,
          end: this.index
        });
      }

      return {
        type: ParamNames_1.default.Literal,
        value: str,
        raw: quote + str + quote
      };
    }
  }, {
    key: "parseIdentifier",
    value: function parseIdentifier() {
      var ch = this.charCodeAt(this.index);
      var start = this.index;
      var identifier;

      if (Chars_1.isIdentifierStart(ch)) {
        this.index++;
      } else {
        throw new ParseError_1.default("Unexpected ".concat(this.charAt(this.index)), {
          start: this.index,
          end: this.index
        });
      }

      while (this.index < this.length) {
        ch = this.charCodeAt(this.index);

        if (Chars_1.isIdentifierPart(ch)) {
          this.index++;
        } else {
          break;
        }
      }

      identifier = this.template.slice(start, this.index);

      if (Chars_1.literals.hasOwnProperty(identifier)) {
        return {
          type: ParamNames_1.default.Literal,
          value: Chars_1.literals[identifier],
          raw: identifier
        };
      } else {
        return {
          type: ParamNames_1.default.Identifier,
          name: identifier
        };
      }
    }
  }, {
    key: "parseArguments",
    value: function parseArguments(termination) {
      var chI;
      var args = [];
      var node;
      var closed = false;

      while (this.index < this.length) {
        this.parseSpaces();
        chI = this.charCodeAt(this.index);

        if (chI === termination) {
          closed = true;
          this.index++;
          break;
        } else if (chI === CharCodes_1.default.Comma) {
          this.index++;
        } else {
          node = this.parseExpression();

          if (!node || node.type === ParamNames_1.default.Compound) {
            throw new ParseError_1.default('Expected comma', {
              start: this.index,
              end: this.index
            });
          }

          args.push(node);
        }
      }

      if (!closed) {
        throw new ParseError_1.default("Expected ".concat(String.fromCharCode(termination)), {
          start: this.index,
          end: this.index
        });
      }

      return args;
    }
  }, {
    key: "parseVariable",
    value: function parseVariable() {
      var chI;
      chI = this.charCodeAt(this.index);
      var node = chI === CharCodes_1.default.OpenParenthesis ? this.parseGroup() : this.parseIdentifier();
      this.parseSpaces();
      chI = this.charCodeAt(this.index);

      while (chI === CharCodes_1.default.Period || chI === CharCodes_1.default.OpenBracket || chI === CharCodes_1.default.OpenParenthesis) {
        this.index++;

        if (chI === CharCodes_1.default.Period) {
          this.parseSpaces();
          node = {
            type: ParamNames_1.default.MemberExpression,
            computed: false,
            object: node,
            property: this.parseIdentifier()
          };
        } else if (chI === CharCodes_1.default.OpenBracket) {
          node = {
            type: ParamNames_1.default.MemberExpression,
            computed: true,
            object: node,
            property: this.parseExpression()
          };
          this.parseSpaces();
          chI = this.charCodeAt(this.index);

          if (chI !== CharCodes_1.default.CloseBracket) {
            throw new ParseError_1.default('Unclosed [', {
              start: this.index,
              end: this.index
            });
          }

          this.index++;
        } else if (chI === CharCodes_1.default.OpenParenthesis) {
          node = {
            type: ParamNames_1.default.CallExpression,
            arguments: this.parseArguments(CharCodes_1.default.CloseParenthesis),
            callee: node
          };
        }

        this.parseSpaces();
        chI = this.charCodeAt(this.index);
      }

      return node;
    }
  }, {
    key: "parseGroup",
    value: function parseGroup() {
      this.index++;
      var node = this.parseExpression();
      this.parseSpaces();

      if (this.charCodeAt(this.index) === CharCodes_1.default.CloseParenthesis) {
        this.index++;
        return node;
      } else {
        throw new ParseError_1.default('Unclosed (', {
          start: this.index,
          end: this.index
        });
      }
    }
  }, {
    key: "parseArray",
    value: function parseArray() {
      this.index++;
      return {
        type: ParamNames_1.default.ArrayExpression,
        elements: this.parseArguments(CharCodes_1.default.CloseBracket)
      };
    }
  }, {
    key: "parseMap",
    value: function parseMap() {
      var ch;
      var closed = false;
      var elements = [];
      ++this.index;

      while (this.index < this.length) {
        this.parseSpaces();
        ch = this.charCodeAt(this.index);

        if (ch === CharCodes_1.default.CloseBrace) {
          ++this.index;
          closed = true;
          break;
        }

        if (ch !== CharCodes_1.default.SingleQuote && ch !== CharCodes_1.default.DoubleQuote) {
          throw new ParseError_1.default("Invalid character ".concat(String.fromCharCode(ch)), {
            start: this.index,
            end: this.index
          });
        }

        var key = this.parseStringLiteral();
        this.parseSpaces();
        ch = this.charCodeAt(this.index);

        if (ch !== CharCodes_1.default.Colon) {
          throw new ParseError_1.default("Invalid character ".concat(String.fromCharCode(ch)), {
            start: this.index,
            end: this.index
          });
        }

        ++this.index;
        this.parseSpaces();
        var value = this.parseExpression();

        if (!value) {
          throw new ParseError_1.default("Invalid character ".concat(String.fromCharCode(ch)), {
            start: this.index,
            end: this.index
          });
        }

        ch = this.charCodeAt(this.index);

        if (ch === CharCodes_1.default.Comma) {
          ++this.index;
        }

        elements.push({
          key: key,
          value: value
        });
      }

      if (!closed) {
        ch = this.charCodeAt(this.index);
        throw new ParseError_1.default('Unclosed {', {
          start: this.index,
          end: this.index
        });
      }

      return {
        type: ParamNames_1.default.MapExpression,
        elements: elements
      };
    }
  }]);

  return ParamsParser;
}(AbstractTokenizer_1.default);

exports.ParamsParser = ParamsParser;